export default {
  userManagement: {
    pageTitle: "Quản lý Người dùng",
    pageDescription: "",
    pageKeywords: "bảo vệ bản quyền, tài sản trí tuệ, bảo vệ nội dung, giám sát AI, thực thi pháp lý, quản lý quyền số, bảo vệ nhà sáng tạo, cấp phép nội dung",

    
  },
  creatorDashboard : {
    pageTitle: "Tổng quan Tác giả",
    pageDescription: "Chào mừng trở lại! Quản lý tác phẩm và theo dõi hiệu suất của bạn",
    pageKeywords: "bảo vệ bản quyền, tài sản trí tuệ, bảo vệ nội dung, giám sát AI, thực thi pháp lý, quản lý quyền số, bảo vệ nhà sáng tạo, cấp phép nội dung",
  }

};
